import React from "react";
import SelectDropdown from "../../components-react/SelectDropdown";
import { NOTIFICATION_TYPE } from "../../../data/Constants";

const NotificationTypeFilter = ({
  selectedNotificationType,
  setSelectedNotificationType,
}) => {

  return (
    <div className="timesheet_dropdown_wrapper">
      <SelectDropdown
        options={NOTIFICATION_TYPE}
        name="Notification Type"
        value={selectedNotificationType}
        setSelectedOption={setSelectedNotificationType}
        isDisable={false}       
        isSearchable={true}
        preventKeyboardOpen={true}
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  );
};

export default NotificationTypeFilter;
